import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Box } from '@material-ui/core';
export function MotionInView({ children, variants, transition, threshold, ...other }) {
    const controls = useAnimation();
    const [ref, inView] = useInView({
        threshold: threshold || 0,
        triggerOnce: true,
    });
    useEffect(() => {
        if (!variants)
            return;
        if (inView) {
            void controls.start(Object.keys(variants)[1]);
        }
        else {
            void controls.start(Object.keys(variants)[0]);
        }
    }, [controls, inView, variants]);
    return (_jsx(Box, Object.assign({ ref: ref, component: motion.div, initial: variants ? Object.keys(variants)[0] : false, animate: controls, variants: variants, transition: transition }, other, { children: children }), void 0));
}
//# sourceMappingURL=MotionInView.js.map